import React from 'react';
import { connect } from 'react-redux';
import shortid from 'shortid';
import { popupHandler } from '../../CommonMethods';
import SponsoredBox from './SponsoredBox';
import NormalBox from './NormalBox';
import PremiumBox from './PremiumBox';
import VerifiedBox from './VerifiedBox';

class Competitor extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {};
    this.getCard = this.getCard.bind(this);
  }

  UNSAFE_componentWillMount() {
    this._isMounted = true;
    setTimeout(function () {
      popupHandler(true, 'threeCompetitorPopup');
    }, 45000);
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getCard = (competitor) => {
    if (competitor.is_sponsored) {
      return <SponsoredBox {...competitor} key={shortid.generate()} />;
    } else {
      if (competitor.type === 'normal') {
        return <NormalBox {...competitor} key={shortid.generate()} />;
      } else if (competitor.type === 'verified') {
        return <VerifiedBox {...competitor} key={shortid.generate()} />;
      } else if (competitor.type === 'premium') {
        return <PremiumBox {...competitor} key={shortid.generate()} />;
      } else {
        return null;
      }
    }
  };

  render() {
    return (
      <section
        class="overlay_popup overlay_grey threeCompetitorPopup"
        aria-hidden="true"
      >
        <div class="popBox">
          <a
            href="#"
            class="close-overlay"
            onClick={(e) => {
              e.preventDefault();
              popupHandler(false, 'threeCompetitorPopup');
            }}
          ></a>
          <div class="popup_overlay_screen">
            <div class="modal-content">
              <div class="modal-body">
                <div class="threeCompetitorPopup_content_box">
                  <div class="top_header_content_block">
                    <h1>Don't see enough customer references?</h1>
                    <h3>Take a look at references from similar vendors</h3>
                  </div>
                  <div class="threeCompetitorListContent">
                    <ul>
                      {this.props.vendorCommon.competitors.map((competitor) =>
                        this.getCard(competitor)
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return { vendorCommon: state.vendorCommon };
};

export default connect(mapStateToProps)(Competitor);
